import { CAL_URL } from "@/lib/data";

// Inline Cal.com scheduler, dark-themed to match the site.
export const CalendlyEmbed = () => {
  const src = `${CAL_URL}?theme=dark`;
  return (
    <iframe
      title="Book a call with TAPSS"
      data-testid="cal-embed"
      src={src}
      width="100%"
      height="720"
      frameBorder="0"
      loading="lazy"
      className="rounded-xl border border-white/10 bg-[#0a0a0a]"
    />
  );
};

export default CalendlyEmbed;
